
import { createStore } from 'vuex'
import VuexPersist from 'vuex-persist'
import state from './state'
import mutations from './mutations'
import * as getters from './getters'
import user from './user'
import customer from './customer'
import admin from './admin'
import theme from './theme'
import navigation from './navigation'
import timeFrame from './timeFrame'
import filters from './filters'
import tableauViz from './tableauViz'
import savedReport from './savedReport'
import feedback from './feedback'
import view from './view'

const debug = import.meta.env.MODE !== 'production'

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  reducer: state => ({
    project: state.project,
    customer: state.customer,
    user: state.user,
    navigation: state.navigation
  })
})

const store = createStore({
  state,
  mutations,
  getters,
  modules: {
    user,
    customer,
    admin,
    theme,
    navigation,
    timeFrame,
    filters,
    tableauViz,
    savedReport,
    feedback,
    view
  },
  strict: debug,
  plugins: [vuexLocalStorage.plugin]
})

export default store
